import { API } from './apiConfig';

///admin/dashboard

export const fetchDashboardData = async () => {
  try {
    const response = await API.get('/api/admin/dashboard');
    return response;
  } catch (error) {
    throw error;
  }
};

export const createUser = async (Data) => {
  try {
    const response = await API.post('/api/admin/users', Data);
    return response;
  } catch (error) {
    throw error;
  }
};


export const getAllUser = async () => {
  try {
    const response = await API.get('/api/admin/users');
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAUser = async (id) => {
  try {
    const response = await API.get(`/api/admin/users/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};


export const updateAUser = async (id,data) => {
  try {
    const response = await API.put(`/api/admin/users/${id}`,data);
    return response;
  } catch (error) {
    throw error;
  }
};


export const deleteAUser = async (id) => {
  try {
    const response = await API.delete(`/api/admin/users/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};


export const toggleAdmin = async (id) => {
  try {
    const response = await API.patch(`/api/admin/users/${id}/toggle-admin`);
    return response;
  } catch (error) {
    throw error;
  }
};


// paymentAPIs
export const getPaymentsOverview = async () => {
  try {
    const response = await API.get(`/api/admin/payments/overview`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAllPayments = async () => {
  try {
    const response = await API.get(`/api/admin/payments`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getSinglePayment = async (id) => {
  try {
    const response = await API.get(`/api/admin/payments/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updatePaymentStatus = async (id) => {
  try {
    const response = await API.put(`/api/admin/payments/${id}/status`);
    return response;
  } catch (error) {
    throw error;
  }
};


export const getAllNotifications = async () => {
  try {
    const response = await API.get(`/api/notifications`);
    return response
  } catch (error) {
    throw error;
  }
};

export const markNotificationAsRead = async (ids) => {
  try {
    const response = await API.put(`/api/mark_notifications/read`, ids);
    return response
  } catch (error) {
    throw error;
  }
};

export const deleteNotification = async (Id) => {
  try {
    const response = await API.delete(`/api/delete/notification/${Id}`);
    return response
  } catch (error) {
    throw error;
  }
};

export const deleteBulkNotifications = async (selectedNotifications) => {
  try {
    const response = await API.post(`/api/delete/bulk_notification`,selectedNotifications);
    return response
  } catch (error) {
    throw error;
  }
};

export const getProductById =(id)=>API.get(`/api/admin/product/${id}`)
export const deleteProduct =(id)=>API.delete(`/api/admin/product/${id}`)
export const updateProduct =(id,formData)=>API.put(`/api/admin/product/${id}`,formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })

export const notifyUsersByRole = (data)=>API.post('/api/admin/notifications/role',data)
export const broadCastNotification = (data)=>API.post('/api/admin/notifications/broadcast',data)
export const getAllReferrals =(params={})=>API.get('/api/admin/referrals',{ params })
export const getReferralDetail=(id)=>API.get(`/api/admin/referrals/${id}`)
export const getReferralStats =()=>API.get('/api/admin/referrals/stats')
  